import Konva from 'konva'

export const getContentPointer = (stage: Konva.Stage | null | undefined) =>
  stage?.getRelativePointerPosition() ?? null
